import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { get, isEmpty } from 'lodash';

import { TopBarSelect } from 'pages/Teachers/shared';
import { trackMixpanelEvent } from 'utils/integrations/mixpanel';
import { parseParams, stringifyParams } from 'utils/urls';

import UserContext from 'components/UserContext';

const ALGEBRA_GEOMETRY_AND_KINDERGARTEN_GRADE_TO_LABEL_MAP = {
  0: 'Kindergarten',
  9: 'Algebra 1',
  10: 'Geometry',
  11: 'Algebra 2'
};

const GradeSelectDropdown = ({
  selectedGrade,
  setSelectedGrade,
  setSelectedUnit,
  setSelectedLesson,
  className,
  grades
}) => {
  const { user } = useContext(UserContext);

  const history = useHistory();
  const urlParams = parseParams(history.location.search);
  const gradeNumber = get(urlParams, 'grade');

  useEffect(() => {
    if (!isEmpty(grades)) {
      const grade = grades.find((grade) => grade.name === gradeNumber);
      if (grade) {
        setSelectedGrade(grade);
      } else {
        const defaultElement = grades.find((element) => element.is_default);
        setSelectedGrade(defaultElement);

        urlParams.grade = defaultElement.name;
        history.replace({ search: stringifyParams(urlParams) });
      }
    } else {
      setSelectedGrade(null);

      delete urlParams.grade;
      delete urlParams.unit;
      delete urlParams.lesson;
      history.replace({ search: stringifyParams(urlParams) });
    }
  }, [grades, setSelectedGrade, gradeNumber, history, urlParams]);

  const selectGrade = (newGrade) => {
    setSelectedLesson(null);
    setSelectedUnit(null);
    setSelectedGrade(newGrade);

    urlParams.grade = newGrade.name;
    history.replace({ search: stringifyParams(urlParams) });

    trackMixpanelEvent(user.id, '[StrategiesOverview] Teacher changed grade.', {
      grade: newGrade.name
    });
  };

  return (
    <TopBarSelect
      value={selectedGrade}
      renderValue={(grade) => `Grade ${get(grade, 'name')}`}
      onChange={selectGrade}
      options={grades.map((grade) => ({
        value: grade,
        label:
          grade.name in ['0', '9', '10', '11']
            ? ALGEBRA_GEOMETRY_AND_KINDERGARTEN_GRADE_TO_LABEL_MAP[grade.name]
            : grade.name
      }))}
      className={className}
    />
  );
};

export default GradeSelectDropdown;
